module.exports = __webpack_public_path__ + "img/banner3_3_vi.04779213.png";